import { Container } from '@vitvio/design-system';
import { lazy, Suspense } from 'react';

export function WholeScreenLoader() {
  if (typeof window === 'undefined') {
    return null;
  }
  const AnimatedLoader = lazy(() => import('./AnimatedLoader'));
  return (
    <Container centerContent>
      <Suspense>
        <AnimatedLoader />
      </Suspense>
    </Container>
  );
}
